export default __webpack_public_path__ + "resources/icons/d321-9ddb.webp";